// Convenience function to easily assign paths
export const withPath = (path) => path;
